// assets/js/utils/slide.js

function waitForTransition(el, duration) {
  return new Promise((resolve) => {
    // Ускоряем для людей с reduced motion
    const prefersReduced = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    )?.matches;
    if (prefersReduced) {
      resolve();
      return;
    }

    let done = false;
    const end = () => {
      if (done) return;
      done = true;
      resolve();
    };

    const onEnd = (e) => {
      if (e.target === el) {
        el.removeEventListener("transitionend", onEnd);
        end();
      }
    };

    el.addEventListener("transitionend", onEnd);
    // Фолбэк на случай, если transitionend не сработает
    setTimeout(() => {
      el.removeEventListener("transitionend", onEnd);
      end();
    }, duration + 80);
  });
}

export function slideUp(el, duration = 400) {
  if (!el || el._slidingPromise) return el?._slidingPromise;

  el.dataset.sliding = "true";
  el.style.height = el.offsetHeight + "px";
  // force reflow
  void el.offsetHeight;

  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;

  el._slidingPromise = waitForTransition(el, duration).then(() => {
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.dataset.sliding = "false";
    el._slidingPromise = null;
    return false; // скрыт
  });

  return el._slidingPromise;
}

export function slideDown(el, displayStyle = "block", duration = 300) {
  if (!el || el._slidingPromise) return el?._slidingPromise;

  el.dataset.sliding = "true";
  el.style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") display = displayStyle !== "flex" ? "block" : "flex";
  el.style.display = display;

  const height = el.scrollHeight;

  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;

  // force reflow
  void el.offsetHeight;

  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.height = height + "px";
  el.style.removeProperty("padding-top");
  el.style.removeProperty("padding-bottom");
  el.style.removeProperty("margin-top");
  el.style.removeProperty("margin-bottom");

  el._slidingPromise = waitForTransition(el, duration).then(() => {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.dataset.sliding = "false";
    el._slidingPromise = null;
    return true; // показан
  });

  return el._slidingPromise;
}

export function slideToggle(el, duration = 300) {
  if (!el || el._slidingPromise) return el?._slidingPromise;
  const isVisible = window.getComputedStyle(el).display !== "none";
  return isVisible ? slideUp(el, duration) : slideDown(el, duration);
}
